export default __webpack_public_path__ + "static/media/azracan5.60240ef6.jpg";